export default __webpack_public_path__ + "15115b3feea5808d02f582eaaafe31d5.png";